module.exports = __webpack_public_path__ + "img/traktor_no.b53de4d1.png";